import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-68">
      <div className="container mx-auto px-4 max-w-5xl text-center" data-id="element-69">
        <div className="text-white font-bold text-xl mb-6" data-id="element-70">
          📚 MASTERPACK DE PROTOCOLOS CLÍNICOS DE NUTRICIÓN
        </div>

        <p className="text-sm max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-71">
          Este producto es una herramienta de apoyo profesional complementaria.
          No reemplaza la formación clínica, el juicio profesional ni la
          relación terapéutica entre el profesional y su paciente. Los
          resultados pueden variar según cada caso y la forma de implementación
          del material.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm mb-8" data-id="element-72">
          <a href="#" className="hover:text-white transition-colors" data-id="element-73">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-74">
            Política de Privacidad
          </a>
          <a href="mailto:soporte@masterpacknutricion.com" className="hover:text-white transition-colors" data-id="element-75">
            Contacto
          </a>
        </div>

        <div className="text-xs text-slate-600" data-id="element-76">
          <p data-id="element-77">
            © {new Date().getFullYear()} Masterpack Protocolos Clínicos de
            Nutrición — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}